import { call, put } from 'redux-saga/effects';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import { retriable } from '../retriable';
import {
    FETCH_WORKFLOW_CONFIG_FAILURE,
    FETCH_WORKFLOW_CONFIG_SUCCESS,
} from '../../redux/modules/workflowConfig/workflowConfig-actions';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage, getJsonPath,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import { APPLICATION_CONFIG_URL } from '../../constants/constants';
import { FETCH_EFORM_CONFIG_SUCCESS } from '../../redux/modules/eformConfig/eformConfig-actions';

function* fetchWorkflowConfigWorkerSaga(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().get, action.api);
        const response2 =
            yield call(retriable().get, getJsonPath('/Workflows/EFormConfiguration.json', APPLICATION_CONFIG_URL));
        console.log('searching', response.data);
        yield put({
            type: FETCH_WORKFLOW_CONFIG_SUCCESS,
            appConfiguration: response.data,
        });
        yield put({
            type: FETCH_EFORM_CONFIG_SUCCESS,
            appConfiguration: response2.data,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        // do error action
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({ type: ERROR_MESSAGE, message: getErrorMessage(e) });
        }
        yield put({ type: FETCH_WORKFLOW_CONFIG_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export default fetchWorkflowConfigWorkerSaga;
